/* src/app/views/template/components/edit-template-menu/edit-template-product-menu/edit-template-product-menu-header/edit-template-product-menu-header.component.scss */
.template-secondary-header {
  display: flex;
  flex-direction: row;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f2f2f2;
}
.left-side-of-header {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.5rem;
}
.right-side-of-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
}
/*# sourceMappingURL=edit-template-product-menu-header.component.css.map */
